import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { urls } from '@/constants/urls';

export type AccountButtonProps = {
  firstName: string;
  lastName: string;
};

export const AccountButton: FC<AccountButtonProps> = ({
  firstName,
  lastName,
}) => {
  const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();

  return (
    <Button
      aria-label="your account"
      as={Link}
      className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-500 text-sm font-medium leading-none text-white"
      to={urls.account}
      variant="unstyled"
    >
      {initials}
    </Button>
  );
};
